<template>
  <div class="site-contents dashboard d-flex align-items-center flex-wrap">
    <div class="container">
      <div class="event-lists events-wrap d-flex flex-wrap justify-content-between">
        <h2 v-if="participated == ''">Participated archived wish lists not found.</h2>
        <h2 v-else>Participated Wish lists Archive</h2>

        <div
          v-for="(event,index) in participated"
          class="d-flex flex-wrap w-100"
          v-bind:key="event._id"
        >
          <div
            v-if="checkIfAdsPlace(index)"
            class="registry-lists d-flex flex-wrap w-100 adsense-inject"
          >
           <!-- advertisement script -->
          </div>
          <div class="registry-lists d-flex flex-wrap w-100">
            <div class="event-img">
              <img v-if="event.image" :src="event.image" />
              <img v-else src="../../public/assets/images/event1.png" />
            </div>
            <div
              class="event-info flex-grow-1"
              v-bind:class="{ bgWhite: ((index%2) !== 0 || index == 1) }"
            >
              <router-link :to="{ path: 'wishlist/'+event._id}">
                <h4>{{event.name}}</h4>
              </router-link>
              <div class="event-date">
                <template v-if="calculateDateDiff(event.date) == false">
                  <p>This event is over.</p>
                </template>
                <template v-else>
                  <p>This event is archived.</p>
                  <p class="date">{{ new Date(event.date).toString() | moment("DD/MM/YYYY")}}</p>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showSpinner" class="spinner">
          <div class="spinner-border" role="status"></div>
        </div>
      </div>
      <div
        class="modal fade"
        id="confirm-delete"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">Are you sure?</div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">No</button>
              <button
                type="button"
                class="btn btn-outline-success"
                v-model="confirmed"
                @click="confirmTrue()"
              >Yes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.adslot { width: 1110px; height: 200px; }
.addmore a {
  padding-bottom: 10px;
}
.crop-button {
  margin-left: 500px;
  margin-top: 10px;
}
.wishlistCreateForm {
  margin-top: 60px;
}
</style>
<script>
import Vuex from "vuex";
import Vue from "vue";
import {
  GET_ARCHIVED_PARTICIPATED_WISHLIST,
  DELETE_WISHLIST
} from "../store/wishlist/action.type";
// import { Validator } from "vee-validate";
import VChip from "v-chip";
import VChipInput from "v-chip/src/v-chip-input.js";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css"; // import the croppie css manually

Vue.use(VueCroppie);
Vue.use(VChip);
Vue.use(VChipInput);

export default {
  name: "webDashboard",

  data() {
    return {
      participated: null,
      totalPages: 0,
      //wihlist actions
      index: null,
      id: null,
      isDelete: false,
      isArchive: false,
      isShare: false,
      confirmed: false,
      wishlistType: null,
      showSpinner: false,
      //paginate
      page: 1,
      perPageLimit: process.env.VUE_APP_API_PER_PAGE_LIMIT || 3,
      googleInit:false,
    };
  },
  mounted() {
    let params = {
      page: this.page,
      perPageLimit: this.perPageLimit
    };

    //get participated events
    this.$store
      .dispatch(GET_ARCHIVED_PARTICIPATED_WISHLIST, params)
      .then(response => {
        // console.log(response);
        this.participated = response.record;
        this.totalPages = response.pagination.totalPages;
      })
      .catch(error => {
        console.log(error);
      });
    //load on scroll
    this.scroll();

  },
  methods: {
    /*delete wishlist */
    deleteWishlist(index, id) {
      $("#confirm-delete").modal("show");
      this.index = index;
      this.id = id;
      this.wishlistType = "participated";
      this.isDelete = true;
      this.isShare = false;
      this.isarchive = false;
    },

    confirmTrue() {
      $("#confirm-delete").modal("hide");
      if (this.isDelete) {
        /* delete wishlist api */
        this.$store
          .dispatch(DELETE_WISHLIST, this.id)
          .then(response => {
            if (response.status == 200) {
              this.$delete(this.participated, this.index);
            } else {
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else if (this.isArchive) {
        /* delete wishlist api */
        this.$store
          .dispatch(ARCHIVE_WISHLIST, this.id)
          .then(response => {
            if (response.status == 200) {
              if (this.wishlistType === "hosted") {
                this.$delete(this.hosted, this.index);
              } else {
                this.$delete(this.participated, this.index);
              }
            } else {
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
      }
    },

    //infinite scroll
    scroll(person) {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;

        if (bottomOfWindow && this.page < this.totalPages) {
          this.page++;
          this.showSpinner = true;
          let params = {
            page: this.page,
            perPageLimit: this.perPageLimit
          };
          //get participated events
          this.$store
            .dispatch(GET_ARCHIVED_PARTICIPATED_WISHLIST, params)
            .then(response => {
              // console.log(response);
              this.participated.push(...response.record);
              this.totalHosted = response.pagination.totalDocs;
              this.showSpinner = false;
              this.injectAdsense();
            })
            .catch(error => {
              this.showSpinner = false;
              console.log(error);
            });
        }
      };
    },
    checkIfAdsPlace(index) {
      if (index != 0 && index % 5 == 0) {
        return true;
      }
    },
    injectAdsense() {
      setTimeout(function() {
        $(".adsense-inject").each(function() {
          // console.log("inside");
          //if not adsense already added
          if (!$(this).hasClass("injected")) {
            $(this).append(
              '<ins class="adsbygoogle adslot"\
               style="display:block"\
               data-ad-client="ca-pub-6256426369998086"\
               data-ad-slot="6912113891"\
               data-ad-format="auto"\
               data-full-width-responsive="true"></ins>'
            );
            setTimeout(() => {
              if (typeof window !== "undefined")
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            }, 2000);
            // (adsbygoogle = window.adsbygoogle || []).push({});
            $(this).addClass("injected");
          }
        });
      }, 2000);
    },
    // calculate date difference for the wishlist
    calculateDateDiff(date) {
      let eventDate = new Date(date);
      let currentDate = new Date();
      if (eventDate - currentDate > 0) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>